export const FILE_ENCODING = {
    ASCII: 'ascii',
    BASE64: 'base64',
    UTF8: 'utf8',
};
